import { ApplicationProfileDtoToEntity } from "src/app/features/ApplicationProfile/services/mappers/ApplicationProfileDtoToEntity";
import type { ApplicationProfileDto } from "src/app/features/ApplicationProfile/types/ApplicationProfileDto";
import type { ApplicationProfileEntity } from "src/app/features/ApplicationProfile/types/ApplicationProfileEntity";
import type { ResourcePageDto } from "../../../../../core/types/be/ResourcePageDto";
import type { ResourcePageEntity } from "../../../../../core/types/fe/entities/ResourcePageEntity";

export const ApplicationProfileTableDtoMapper = (
    input: Readonly<ResourcePageDto<ApplicationProfileDto>>,
): ResourcePageEntity<ApplicationProfileEntity> => {
    return {
        list: input.list ? input.list.map(ApplicationProfileDtoToEntity) : [],
        currentPage: input.currentPage,
        totalPages: input.totalPages,
        totalNumberOfResults: input.totalNumberOfResults,
    };
};
